'use client';
/**
 * This file was automatically generated by the Stencil React Output Target.
 * Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 */
/* eslint-disable */
import { BiIconAddSmall as BiIconAddSmallElement, defineCustomElement as defineBiIconAddSmall } from "@bi-digital/icons/dist/components/bi-icon-add-small.js";
import { BiIconAdd as BiIconAddElement, defineCustomElement as defineBiIconAdd } from "@bi-digital/icons/dist/components/bi-icon-add.js";
import { BiIconArrowDown as BiIconArrowDownElement, defineCustomElement as defineBiIconArrowDown } from "@bi-digital/icons/dist/components/bi-icon-arrow-down.js";
import { BiIconArrowLeft as BiIconArrowLeftElement, defineCustomElement as defineBiIconArrowLeft } from "@bi-digital/icons/dist/components/bi-icon-arrow-left.js";
import { BiIconArrowRight as BiIconArrowRightElement, defineCustomElement as defineBiIconArrowRight } from "@bi-digital/icons/dist/components/bi-icon-arrow-right.js";
import { BiIconArrowUp as BiIconArrowUpElement, defineCustomElement as defineBiIconArrowUp } from "@bi-digital/icons/dist/components/bi-icon-arrow-up.js";
import { BiIconAttachFile as BiIconAttachFileElement, defineCustomElement as defineBiIconAttachFile } from "@bi-digital/icons/dist/components/bi-icon-attach-file.js";
import { BiIconCalendarAdd as BiIconCalendarAddElement, defineCustomElement as defineBiIconCalendarAdd } from "@bi-digital/icons/dist/components/bi-icon-calendar-add.js";
import { BiIconCalendarFullTime as BiIconCalendarFullTimeElement, defineCustomElement as defineBiIconCalendarFullTime } from "@bi-digital/icons/dist/components/bi-icon-calendar-full-time.js";
import { BiIconCalendarPartTime as BiIconCalendarPartTimeElement, defineCustomElement as defineBiIconCalendarPartTime } from "@bi-digital/icons/dist/components/bi-icon-calendar-part-time.js";
import { BiIconCalendarStartDate as BiIconCalendarStartDateElement, defineCustomElement as defineBiIconCalendarStartDate } from "@bi-digital/icons/dist/components/bi-icon-calendar-start-date.js";
import { BiIconCalendar as BiIconCalendarElement, defineCustomElement as defineBiIconCalendar } from "@bi-digital/icons/dist/components/bi-icon-calendar.js";
import { BiIconCartFilled as BiIconCartFilledElement, defineCustomElement as defineBiIconCartFilled } from "@bi-digital/icons/dist/components/bi-icon-cart-filled.js";
import { BiIconCart as BiIconCartElement, defineCustomElement as defineBiIconCart } from "@bi-digital/icons/dist/components/bi-icon-cart.js";
import { BiIconChat as BiIconChatElement, defineCustomElement as defineBiIconChat } from "@bi-digital/icons/dist/components/bi-icon-chat.js";
import { BiIconCheckmarkSmall as BiIconCheckmarkSmallElement, defineCustomElement as defineBiIconCheckmarkSmall } from "@bi-digital/icons/dist/components/bi-icon-checkmark-small.js";
import { BiIconCheckmark as BiIconCheckmarkElement, defineCustomElement as defineBiIconCheckmark } from "@bi-digital/icons/dist/components/bi-icon-checkmark.js";
import { BiIconChevronDown as BiIconChevronDownElement, defineCustomElement as defineBiIconChevronDown } from "@bi-digital/icons/dist/components/bi-icon-chevron-down.js";
import { BiIconChevronLeftLarge as BiIconChevronLeftLargeElement, defineCustomElement as defineBiIconChevronLeftLarge } from "@bi-digital/icons/dist/components/bi-icon-chevron-left-large.js";
import { BiIconChevronLeft as BiIconChevronLeftElement, defineCustomElement as defineBiIconChevronLeft } from "@bi-digital/icons/dist/components/bi-icon-chevron-left.js";
import { BiIconChevronRightLarge as BiIconChevronRightLargeElement, defineCustomElement as defineBiIconChevronRightLarge } from "@bi-digital/icons/dist/components/bi-icon-chevron-right-large.js";
import { BiIconChevronRight as BiIconChevronRightElement, defineCustomElement as defineBiIconChevronRight } from "@bi-digital/icons/dist/components/bi-icon-chevron-right.js";
import { BiIconChevronUp as BiIconChevronUpElement, defineCustomElement as defineBiIconChevronUp } from "@bi-digital/icons/dist/components/bi-icon-chevron-up.js";
import { BiIconClock as BiIconClockElement, defineCustomElement as defineBiIconClock } from "@bi-digital/icons/dist/components/bi-icon-clock.js";
import { BiIconCopy as BiIconCopyElement, defineCustomElement as defineBiIconCopy } from "@bi-digital/icons/dist/components/bi-icon-copy.js";
import { BiIconCourse as BiIconCourseElement, defineCustomElement as defineBiIconCourse } from "@bi-digital/icons/dist/components/bi-icon-course.js";
import { BiIconCreditCard as BiIconCreditCardElement, defineCustomElement as defineBiIconCreditCard } from "@bi-digital/icons/dist/components/bi-icon-credit-card.js";
import { BiIconCrossSmall as BiIconCrossSmallElement, defineCustomElement as defineBiIconCrossSmall } from "@bi-digital/icons/dist/components/bi-icon-cross-small.js";
import { BiIconCross as BiIconCrossElement, defineCustomElement as defineBiIconCross } from "@bi-digital/icons/dist/components/bi-icon-cross.js";
import { BiIconDocumentProgress as BiIconDocumentProgressElement, defineCustomElement as defineBiIconDocumentProgress } from "@bi-digital/icons/dist/components/bi-icon-document-progress.js";
import { BiIconDocument as BiIconDocumentElement, defineCustomElement as defineBiIconDocument } from "@bi-digital/icons/dist/components/bi-icon-document.js";
import { BiIconDownload as BiIconDownloadElement, defineCustomElement as defineBiIconDownload } from "@bi-digital/icons/dist/components/bi-icon-download.js";
import { BiIconEdit as BiIconEditElement, defineCustomElement as defineBiIconEdit } from "@bi-digital/icons/dist/components/bi-icon-edit.js";
import { BiIconElements as BiIconElementsElement, defineCustomElement as defineBiIconElements } from "@bi-digital/icons/dist/components/bi-icon-elements.js";
import { BiIconEllipseEmpty as BiIconEllipseEmptyElement, defineCustomElement as defineBiIconEllipseEmpty } from "@bi-digital/icons/dist/components/bi-icon-ellipse-empty.js";
import { BiIconEllipseFilled as BiIconEllipseFilledElement, defineCustomElement as defineBiIconEllipseFilled } from "@bi-digital/icons/dist/components/bi-icon-ellipse-filled.js";
import { BiIconEllipseHalf as BiIconEllipseHalfElement, defineCustomElement as defineBiIconEllipseHalf } from "@bi-digital/icons/dist/components/bi-icon-ellipse-half.js";
import { BiIconError as BiIconErrorElement, defineCustomElement as defineBiIconError } from "@bi-digital/icons/dist/components/bi-icon-error.js";
import { BiIconExamTask as BiIconExamTaskElement, defineCustomElement as defineBiIconExamTask } from "@bi-digital/icons/dist/components/bi-icon-exam-task.js";
import { BiIconExam as BiIconExamElement, defineCustomElement as defineBiIconExam } from "@bi-digital/icons/dist/components/bi-icon-exam.js";
import { BiIconFacebook as BiIconFacebookElement, defineCustomElement as defineBiIconFacebook } from "@bi-digital/icons/dist/components/bi-icon-facebook.js";
import { BiIconFavouriteExpanding as BiIconFavouriteExpandingElement, defineCustomElement as defineBiIconFavouriteExpanding } from "@bi-digital/icons/dist/components/bi-icon-favourite-expanding.js";
import { BiIconFavouriteFill as BiIconFavouriteFillElement, defineCustomElement as defineBiIconFavouriteFill } from "@bi-digital/icons/dist/components/bi-icon-favourite-fill.js";
import { BiIconFavourite as BiIconFavouriteElement, defineCustomElement as defineBiIconFavourite } from "@bi-digital/icons/dist/components/bi-icon-favourite.js";
import { BiIconFigmaLogo as BiIconFigmaLogoElement, defineCustomElement as defineBiIconFigmaLogo } from "@bi-digital/icons/dist/components/bi-icon-figma-logo.js";
import { BiIconFilterList as BiIconFilterListElement, defineCustomElement as defineBiIconFilterList } from "@bi-digital/icons/dist/components/bi-icon-filter-list.js";
import { BiIconGroupExpanding as BiIconGroupExpandingElement, defineCustomElement as defineBiIconGroupExpanding } from "@bi-digital/icons/dist/components/bi-icon-group-expanding.js";
import { BiIconGroupUnit as BiIconGroupUnitElement, defineCustomElement as defineBiIconGroupUnit } from "@bi-digital/icons/dist/components/bi-icon-group-unit.js";
import { BiIconInformation as BiIconInformationElement, defineCustomElement as defineBiIconInformation } from "@bi-digital/icons/dist/components/bi-icon-information.js";
import { BiIconInstagram as BiIconInstagramElement, defineCustomElement as defineBiIconInstagram } from "@bi-digital/icons/dist/components/bi-icon-instagram.js";
import { BiIconJournal as BiIconJournalElement, defineCustomElement as defineBiIconJournal } from "@bi-digital/icons/dist/components/bi-icon-journal.js";
import { BiIconKeep as BiIconKeepElement, defineCustomElement as defineBiIconKeep } from "@bi-digital/icons/dist/components/bi-icon-keep.js";
import { BiIconLadder as BiIconLadderElement, defineCustomElement as defineBiIconLadder } from "@bi-digital/icons/dist/components/bi-icon-ladder.js";
import { BiIconLayer as BiIconLayerElement, defineCustomElement as defineBiIconLayer } from "@bi-digital/icons/dist/components/bi-icon-layer.js";
import { BiIconLink as BiIconLinkElement, defineCustomElement as defineBiIconLink } from "@bi-digital/icons/dist/components/bi-icon-link.js";
import { BiIconLinkedin as BiIconLinkedinElement, defineCustomElement as defineBiIconLinkedin } from "@bi-digital/icons/dist/components/bi-icon-linkedin.js";
import { BiIconLocation as BiIconLocationElement, defineCustomElement as defineBiIconLocation } from "@bi-digital/icons/dist/components/bi-icon-location.js";
import { BiIconMagnefyingGlass as BiIconMagnefyingGlassElement, defineCustomElement as defineBiIconMagnefyingGlass } from "@bi-digital/icons/dist/components/bi-icon-magnefying-glass.js";
import { BiIconMail as BiIconMailElement, defineCustomElement as defineBiIconMail } from "@bi-digital/icons/dist/components/bi-icon-mail.js";
import { BiIconMenu as BiIconMenuElement, defineCustomElement as defineBiIconMenu } from "@bi-digital/icons/dist/components/bi-icon-menu.js";
import { BiIconOpenInPhone as BiIconOpenInPhoneElement, defineCustomElement as defineBiIconOpenInPhone } from "@bi-digital/icons/dist/components/bi-icon-open-in-phone.js";
import { BiIconOpen as BiIconOpenElement, defineCustomElement as defineBiIconOpen } from "@bi-digital/icons/dist/components/bi-icon-open.js";
import { BiIconOptionsHorizontal as BiIconOptionsHorizontalElement, defineCustomElement as defineBiIconOptionsHorizontal } from "@bi-digital/icons/dist/components/bi-icon-options-horizontal.js";
import { BiIconOptionsVertical as BiIconOptionsVerticalElement, defineCustomElement as defineBiIconOptionsVertical } from "@bi-digital/icons/dist/components/bi-icon-options-vertical.js";
import { BiIconPdf as BiIconPdfElement, defineCustomElement as defineBiIconPdf } from "@bi-digital/icons/dist/components/bi-icon-pdf.js";
import { BiIconPhone as BiIconPhoneElement, defineCustomElement as defineBiIconPhone } from "@bi-digital/icons/dist/components/bi-icon-phone.js";
import { BiIconPodcastApple as BiIconPodcastAppleElement, defineCustomElement as defineBiIconPodcastApple } from "@bi-digital/icons/dist/components/bi-icon-podcast-apple.js";
import { BiIconPodcastGoogle as BiIconPodcastGoogleElement, defineCustomElement as defineBiIconPodcastGoogle } from "@bi-digital/icons/dist/components/bi-icon-podcast-google.js";
import { BiIconPodcastSpotify as BiIconPodcastSpotifyElement, defineCustomElement as defineBiIconPodcastSpotify } from "@bi-digital/icons/dist/components/bi-icon-podcast-spotify.js";
import { BiIconPodcast as BiIconPodcastElement, defineCustomElement as defineBiIconPodcast } from "@bi-digital/icons/dist/components/bi-icon-podcast.js";
import { BiIconPrice as BiIconPriceElement, defineCustomElement as defineBiIconPrice } from "@bi-digital/icons/dist/components/bi-icon-price.js";
import { BiIconPrint as BiIconPrintElement, defineCustomElement as defineBiIconPrint } from "@bi-digital/icons/dist/components/bi-icon-print.js";
import { BiIconProgression as BiIconProgressionElement, defineCustomElement as defineBiIconProgression } from "@bi-digital/icons/dist/components/bi-icon-progression.js";
import { BiIconRedo as BiIconRedoElement, defineCustomElement as defineBiIconRedo } from "@bi-digital/icons/dist/components/bi-icon-redo.js";
import { BiIconRobot as BiIconRobotElement, defineCustomElement as defineBiIconRobot } from "@bi-digital/icons/dist/components/bi-icon-robot.js";
import { BiIconSchool as BiIconSchoolElement, defineCustomElement as defineBiIconSchool } from "@bi-digital/icons/dist/components/bi-icon-school.js";
import { BiIconStopwatchTwo as BiIconStopwatchTwoElement, defineCustomElement as defineBiIconStopwatchTwo } from "@bi-digital/icons/dist/components/bi-icon-stopwatch-two.js";
import { BiIconStopwatch as BiIconStopwatchElement, defineCustomElement as defineBiIconStopwatch } from "@bi-digital/icons/dist/components/bi-icon-stopwatch.js";
import { BiIconSubtractSmall as BiIconSubtractSmallElement, defineCustomElement as defineBiIconSubtractSmall } from "@bi-digital/icons/dist/components/bi-icon-subtract-small.js";
import { BiIconSubtract as BiIconSubtractElement, defineCustomElement as defineBiIconSubtract } from "@bi-digital/icons/dist/components/bi-icon-subtract.js";
import { BiIconTogglebutton as BiIconTogglebuttonElement, defineCustomElement as defineBiIconTogglebutton } from "@bi-digital/icons/dist/components/bi-icon-togglebutton.js";
import { BiIconTrash as BiIconTrashElement, defineCustomElement as defineBiIconTrash } from "@bi-digital/icons/dist/components/bi-icon-trash.js";
import { BiIconTwoArrows as BiIconTwoArrowsElement, defineCustomElement as defineBiIconTwoArrows } from "@bi-digital/icons/dist/components/bi-icon-two-arrows.js";
import { BiIconUpload as BiIconUploadElement, defineCustomElement as defineBiIconUpload } from "@bi-digital/icons/dist/components/bi-icon-upload.js";
import { BiIconUser as BiIconUserElement, defineCustomElement as defineBiIconUser } from "@bi-digital/icons/dist/components/bi-icon-user.js";
import { BiIconWarning as BiIconWarningElement, defineCustomElement as defineBiIconWarning } from "@bi-digital/icons/dist/components/bi-icon-warning.js";
import { BiIconWorld as BiIconWorldElement, defineCustomElement as defineBiIconWorld } from "@bi-digital/icons/dist/components/bi-icon-world.js";
import { BiIconX as BiIconXElement, defineCustomElement as defineBiIconX } from "@bi-digital/icons/dist/components/bi-icon-x.js";
import { createComponent } from '@stencil/react-output-target/runtime';
import React from 'react';
export const BiIconAdd = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-add',
    elementClass: BiIconAddElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconAdd
});
export const BiIconAddSmall = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-add-small',
    elementClass: BiIconAddSmallElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconAddSmall
});
export const BiIconArrowDown = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-arrow-down',
    elementClass: BiIconArrowDownElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconArrowDown
});
export const BiIconArrowLeft = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-arrow-left',
    elementClass: BiIconArrowLeftElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconArrowLeft
});
export const BiIconArrowRight = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-arrow-right',
    elementClass: BiIconArrowRightElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconArrowRight
});
export const BiIconArrowUp = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-arrow-up',
    elementClass: BiIconArrowUpElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconArrowUp
});
export const BiIconAttachFile = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-attach-file',
    elementClass: BiIconAttachFileElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconAttachFile
});
export const BiIconCalendar = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-calendar',
    elementClass: BiIconCalendarElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCalendar
});
export const BiIconCalendarAdd = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-calendar-add',
    elementClass: BiIconCalendarAddElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCalendarAdd
});
export const BiIconCalendarFullTime = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-calendar-full-time',
    elementClass: BiIconCalendarFullTimeElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCalendarFullTime
});
export const BiIconCalendarPartTime = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-calendar-part-time',
    elementClass: BiIconCalendarPartTimeElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCalendarPartTime
});
export const BiIconCalendarStartDate = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-calendar-start-date',
    elementClass: BiIconCalendarStartDateElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCalendarStartDate
});
export const BiIconCart = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-cart',
    elementClass: BiIconCartElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCart
});
export const BiIconCartFilled = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-cart-filled',
    elementClass: BiIconCartFilledElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCartFilled
});
export const BiIconChat = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-chat',
    elementClass: BiIconChatElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconChat
});
export const BiIconCheckmark = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-checkmark',
    elementClass: BiIconCheckmarkElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCheckmark
});
export const BiIconCheckmarkSmall = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-checkmark-small',
    elementClass: BiIconCheckmarkSmallElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCheckmarkSmall
});
export const BiIconChevronDown = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-chevron-down',
    elementClass: BiIconChevronDownElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconChevronDown
});
export const BiIconChevronLeft = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-chevron-left',
    elementClass: BiIconChevronLeftElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconChevronLeft
});
export const BiIconChevronLeftLarge = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-chevron-left-large',
    elementClass: BiIconChevronLeftLargeElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconChevronLeftLarge
});
export const BiIconChevronRight = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-chevron-right',
    elementClass: BiIconChevronRightElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconChevronRight
});
export const BiIconChevronRightLarge = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-chevron-right-large',
    elementClass: BiIconChevronRightLargeElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconChevronRightLarge
});
export const BiIconChevronUp = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-chevron-up',
    elementClass: BiIconChevronUpElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconChevronUp
});
export const BiIconClock = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-clock',
    elementClass: BiIconClockElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconClock
});
export const BiIconCopy = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-copy',
    elementClass: BiIconCopyElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCopy
});
export const BiIconCourse = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-course',
    elementClass: BiIconCourseElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCourse
});
export const BiIconCreditCard = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-credit-card',
    elementClass: BiIconCreditCardElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCreditCard
});
export const BiIconCross = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-cross',
    elementClass: BiIconCrossElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCross
});
export const BiIconCrossSmall = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-cross-small',
    elementClass: BiIconCrossSmallElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconCrossSmall
});
export const BiIconDocument = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-document',
    elementClass: BiIconDocumentElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconDocument
});
export const BiIconDocumentProgress = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-document-progress',
    elementClass: BiIconDocumentProgressElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconDocumentProgress
});
export const BiIconDownload = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-download',
    elementClass: BiIconDownloadElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconDownload
});
export const BiIconEdit = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-edit',
    elementClass: BiIconEditElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconEdit
});
export const BiIconElements = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-elements',
    elementClass: BiIconElementsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconElements
});
export const BiIconEllipseEmpty = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-ellipse-empty',
    elementClass: BiIconEllipseEmptyElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconEllipseEmpty
});
export const BiIconEllipseFilled = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-ellipse-filled',
    elementClass: BiIconEllipseFilledElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconEllipseFilled
});
export const BiIconEllipseHalf = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-ellipse-half',
    elementClass: BiIconEllipseHalfElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconEllipseHalf
});
export const BiIconError = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-error',
    elementClass: BiIconErrorElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconError
});
export const BiIconExam = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-exam',
    elementClass: BiIconExamElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconExam
});
export const BiIconExamTask = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-exam-task',
    elementClass: BiIconExamTaskElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconExamTask
});
export const BiIconFacebook = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-facebook',
    elementClass: BiIconFacebookElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconFacebook
});
export const BiIconFavourite = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-favourite',
    elementClass: BiIconFavouriteElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconFavourite
});
export const BiIconFavouriteExpanding = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-favourite-expanding',
    elementClass: BiIconFavouriteExpandingElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconFavouriteExpanding
});
export const BiIconFavouriteFill = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-favourite-fill',
    elementClass: BiIconFavouriteFillElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconFavouriteFill
});
export const BiIconFigmaLogo = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-figma-logo',
    elementClass: BiIconFigmaLogoElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconFigmaLogo
});
export const BiIconFilterList = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-filter-list',
    elementClass: BiIconFilterListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconFilterList
});
export const BiIconGroupExpanding = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-group-expanding',
    elementClass: BiIconGroupExpandingElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconGroupExpanding
});
export const BiIconGroupUnit = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-group-unit',
    elementClass: BiIconGroupUnitElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconGroupUnit
});
export const BiIconInformation = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-information',
    elementClass: BiIconInformationElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconInformation
});
export const BiIconInstagram = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-instagram',
    elementClass: BiIconInstagramElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconInstagram
});
export const BiIconJournal = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-journal',
    elementClass: BiIconJournalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconJournal
});
export const BiIconKeep = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-keep',
    elementClass: BiIconKeepElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconKeep
});
export const BiIconLadder = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-ladder',
    elementClass: BiIconLadderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconLadder
});
export const BiIconLayer = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-layer',
    elementClass: BiIconLayerElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconLayer
});
export const BiIconLink = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-link',
    elementClass: BiIconLinkElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconLink
});
export const BiIconLinkedin = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-linkedin',
    elementClass: BiIconLinkedinElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconLinkedin
});
export const BiIconLocation = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-location',
    elementClass: BiIconLocationElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconLocation
});
export const BiIconMagnefyingGlass = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-magnefying-glass',
    elementClass: BiIconMagnefyingGlassElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconMagnefyingGlass
});
export const BiIconMail = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-mail',
    elementClass: BiIconMailElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconMail
});
export const BiIconMenu = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-menu',
    elementClass: BiIconMenuElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconMenu
});
export const BiIconOpen = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-open',
    elementClass: BiIconOpenElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconOpen
});
export const BiIconOpenInPhone = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-open-in-phone',
    elementClass: BiIconOpenInPhoneElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconOpenInPhone
});
export const BiIconOptionsHorizontal = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-options-horizontal',
    elementClass: BiIconOptionsHorizontalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconOptionsHorizontal
});
export const BiIconOptionsVertical = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-options-vertical',
    elementClass: BiIconOptionsVerticalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconOptionsVertical
});
export const BiIconPdf = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-pdf',
    elementClass: BiIconPdfElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconPdf
});
export const BiIconPhone = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-phone',
    elementClass: BiIconPhoneElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconPhone
});
export const BiIconPodcast = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-podcast',
    elementClass: BiIconPodcastElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconPodcast
});
export const BiIconPodcastApple = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-podcast-apple',
    elementClass: BiIconPodcastAppleElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconPodcastApple
});
export const BiIconPodcastGoogle = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-podcast-google',
    elementClass: BiIconPodcastGoogleElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconPodcastGoogle
});
export const BiIconPodcastSpotify = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-podcast-spotify',
    elementClass: BiIconPodcastSpotifyElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconPodcastSpotify
});
export const BiIconPrice = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-price',
    elementClass: BiIconPriceElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconPrice
});
export const BiIconPrint = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-print',
    elementClass: BiIconPrintElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconPrint
});
export const BiIconProgression = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-progression',
    elementClass: BiIconProgressionElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconProgression
});
export const BiIconRedo = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-redo',
    elementClass: BiIconRedoElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconRedo
});
export const BiIconRobot = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-robot',
    elementClass: BiIconRobotElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconRobot
});
export const BiIconSchool = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-school',
    elementClass: BiIconSchoolElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconSchool
});
export const BiIconStopwatch = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-stopwatch',
    elementClass: BiIconStopwatchElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconStopwatch
});
export const BiIconStopwatchTwo = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-stopwatch-two',
    elementClass: BiIconStopwatchTwoElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconStopwatchTwo
});
export const BiIconSubtract = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-subtract',
    elementClass: BiIconSubtractElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconSubtract
});
export const BiIconSubtractSmall = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-subtract-small',
    elementClass: BiIconSubtractSmallElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconSubtractSmall
});
export const BiIconTogglebutton = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-togglebutton',
    elementClass: BiIconTogglebuttonElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconTogglebutton
});
export const BiIconTrash = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-trash',
    elementClass: BiIconTrashElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconTrash
});
export const BiIconTwoArrows = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-two-arrows',
    elementClass: BiIconTwoArrowsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconTwoArrows
});
export const BiIconUpload = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-upload',
    elementClass: BiIconUploadElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconUpload
});
export const BiIconUser = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-user',
    elementClass: BiIconUserElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconUser
});
export const BiIconWarning = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-warning',
    elementClass: BiIconWarningElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconWarning
});
export const BiIconWorld = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-world',
    elementClass: BiIconWorldElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconWorld
});
export const BiIconX = /*@__PURE__*/ createComponent({
    tagName: 'bi-icon-x',
    elementClass: BiIconXElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineBiIconX
});
